<template>
    <transition name="modal">
        <div class="modal-wrapper">
            <b-card class="modal-lancement"> 
                <b-row no-gutters>
                    <b-col>
                        <b-card-text class ="lancementJeu pt-2 pb-2">
                        Lancement du jeu de requête : <strong>{{jeuRequete.nom}}</strong>
                        </b-card-text>
                        <b-card-text class ="lancementJeu pt-2 pb-2">
                          Veuillez saisir les paramètres:

                          <div for="input-default" v-if="parametres.length!==0">
                            <div v-for="param in parametres" v-bind:key="param.idParametre">
                              <b-form-group
                              :label="param.valeur"
                              label-cols-sm="4"
                              label-cols-lg="4"
                              label-align="left"
                              label-for="input-horizontal">
                                <b-form-input
                                    v-model="saisieMap[param.idParametre]">
                                </b-form-input>

                              </b-form-group>
                            </div>
                          </div>

                        </b-card-text>
                        <b-card-text class ="lancementJeu pt-2 pb-2">
                          Veuillez sélectionner la base de données ciblée pour le schéma

                          <div>
                            <b-form-select id="input-3" class="textForm" v-model="idBdd" :disabled="lectureSeule" >
                              <option v-for="bdd in bdds" v-bind:value="bdd.idBdd" v-bind:key="bdd.idBdd">{{bdd.nomBdd}}</option>
                            </b-form-select>

                          </div>

                        </b-card-text>
                    </b-col>
                </b-row>
                <b-button pill @click ="lancerJeu" class="nav-link3 m-2">Lancer le jeu</b-button>
                <b-button pill class="nav-link2 m-2" @click="$emit('close')">Annuler</b-button>
            </b-card>
        </div>
    </transition>
</template>

<script>

import {useLancement} from "@/composition/Lancement/modalLancement";
export default {
    name: 'JeuLancement',
    props: {
        jeuRequete:{
            required:true,
            type:Object
        },
        idjeu:{
            type:Number
        },
        parametres:{
            type:Array
        },
        lectureSeule:{
            type:Boolean,
            default:false
        }
    },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props, { emit }) {
    return useLancement(props,{emit});
  }
};
</script>

<style>
.param{
    width: 80%;
}
.select{
    width: 50%;
}

.lancement{
    text-align: center;
}
.col-form-label{
  font-weight: bold;
}

.modal-wrapper {
  vertical-align: middle;
  margin-left: -4em !important;
  margin-right: -4em !important;
}

.modal-lancement {
  text-align: center !important;
  width: 80%;
  margin: 0px auto;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
